import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./FeaturedGames.css";
import Splash from "../../common/Splash";

const FeaturedGames = ({
  title = "Featured Games",
  providers = [],
  slidersFeatures,
}) => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const scrollAmount = 200;
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isLoggedIn] = useState(!!localStorage.getItem("token"));
  const [isMobile] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const origin = window.location.origin;

  // Fetch games data

  const handleGameClick = async (gameCode, gamePlatform, gameType) => {
 
    if (!isLoggedIn) {
        navigate('/login');
        return;
    }

    const token = localStorage.getItem('token');
    const remote_id = localStorage.getItem('remote_id');

    if (!token || !remote_id) {
        setError('User not logged in');
        return;
    }

    setIsLoading(true);

    try {
        // Direct URL support (for hot/featured games that already have a launch URL)
        if (typeof gameCode === 'string' && /^https?:\/\//i.test(gameCode)) {
            navigate('/gamerun', { state: { iframeUrl: gameCode } });
            return;
        }

        // Allow calling with only gameCode by parsing platform and type from the code if needed
        if ((!gamePlatform || !gameType) && typeof gameCode === 'string' && gameCode.includes('-')) {
            const parts = gameCode.split('-');
            if (parts.length >= 2) {
                gamePlatform = parts[0];
                gameType = parts[1];
            }
        }
        if (gamePlatform === 'Lucky' || gamePlatform === 'LuckySpodddrt') {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/player-login`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ user_id: remote_id }),
            });

            const dataly = await response.json();
            if (dataly?.access_token) {
                navigate('/gamerun', {
                    state: { iframeUrl: `https://sprodm.uni247.xyz/?access_token=${dataly.access_token}` },
                });
                return; 
            }
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inr-game-run`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                userId: remote_id,
                externalURL: origin,
                isMobileLogin: isMobile,
                gameCode: gameCode,
                gameType: gameType,
                platform: gamePlatform,
            }),
        });

        const data = await response.json();

        if (response.ok) {
            const iframeUrl = data?.url || data?.data?.payload?.game_launch_url;
            if (iframeUrl) {
                navigate('/gamerun', { state: { iframeUrl } });
            } else {
                setError(data.message || 'An unexpected error occurred');
            } 
        } else {
            setError(data.message || 'An unexpected error occurred');
        }
    } catch (error) {
        console.error('Error launching game:', error);
        setError('An unexpected error occurred');
    } finally {
        setIsLoading(false);
    }
};
  if (isLoading) {
    return <Splash />;
  }
  return (
    <section className="provider-section extra">
      <div className="section-header">
        <h2>
          <div className="lineBorder"></div> {title}
        </h2>

        <div className="nav-buttons">
          <button className="nav-btn" onClick={() => scroll("left")}>
            {" "}
            <svg width="20" height="20" viewBox="0 0 20 20">
              <path
                d="M12 16L6 10L12 4"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </button>
          <button className="nav-btn" onClick={() => scroll("right")}>
            {" "}
            <svg width="20" height="20" viewBox="0 0 20 20">
              <path
                d="M8 4L14 10L8 16"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="provider-scroll" ref={scrollRef}>
        {slidersFeatures.map((game,index) => (
          <div
            key={game.id}
            className="provider-cards games-box"
            onClick={() => handleGameClick(game.link)}
   
          >
            <div className="provider-logo">
              <img
                className="f-img"
                alt={game.name}
                loading="lazy"
                src={`${process.env.REACT_APP_API_URL}/storage/${game.thubmnail}`}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedGames;
